__turbopack_context__.v({
  "customLoader": "qDkVUq_customLoader",
  "customLoader__bar": "qDkVUq_customLoader__bar",
  "fullHeight": "qDkVUq_fullHeight",
  "lds-ellipsis1": "qDkVUq_lds-ellipsis1",
  "lds-ellipsis2": "qDkVUq_lds-ellipsis2",
  "lds-ellipsis3": "qDkVUq_lds-ellipsis3",
  "lds-ellipsis4": "qDkVUq_lds-ellipsis4",
  "loaderWrapper": "qDkVUq_loaderWrapper",
  "miniHeight": "qDkVUq_miniHeight",
  "smallHeight": "qDkVUq_smallHeight",
});
